import { render, staticRenderFns } from "./PolyIntegerReferenceShow.vue?vue&type=template&id=38feeba4&"
import script from "./PolyIntegerReferenceShow.vue?vue&type=script&lang=js&"
export * from "./PolyIntegerReferenceShow.vue?vue&type=script&lang=js&"
import style0 from "./PolyIntegerReferenceShow.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports